<template>
<div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>
    <div class="container-fluid mt--8 mb-5">
        <b-card>
            <template slot="header">
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-6">
                            <h3 class="mb-0">รายละเอียดใบเสร็จ</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="d-flex justify-content-end">
                                <div class="row">
                                    <router-link
                                    class="btn btn-sm btn-primary px-3"
                                    target="_blank"
                                    :to="`/receipt/${orderId}`">
                                    ดูใบเสร็จ
                                    </router-link>
                                    <button class="btn btn-sm btn-info px-3"
                                        :disabled="titleReceipt.status === 'CANCEL'"
                                        @click="printReceipt( orderId )" >
                                        พิมพ์ใบเสร็จ
                                    </button>
                                    <!-- <button class="btn btn-sm btn-info px-3">ใบปะหน้า</button> -->
                                    <b-dropdown size="sm" right text="ใบปะหน้า" variant="warning" :disabled="titleReceipt.status === 'CANCEL'">
                                        <BtnLabel :labelId="orderId" />
                                     </b-dropdown>
                                    <!-- <router-link :to="`/historycancel`">
                                        <button class="btn btn-sm btn-info px-3">ประวัติยกเลิกรายการ</button>
                                    </router-link> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="col-lg-12">
                <b-card header="Default" class="receipt-header">
                    <template slot="header">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-6">
                                    <h5 class="mb-0">
                                        <span class="label">รหัสรายการ:</span> 
                                        <span class="text-value"> {{titleReceipt.receipt_no}}</span>
                                    </h5>
                                </div>
                                <div class="col-lg-6">
                                    <div class="d-flex justify-content-end">
                                        <div class="row">
                                            <h5 class="p-1"><span class="label">วันที่:</span> {{titleReceipt.create_at}}</h5>
                                            <h5 class="p-1">
                                                <b-badge :variant="statusOrder( titleReceipt.status ).color">
                                                    {{ statusOrder( titleReceipt.status ).status }}
                                                </b-badge>
                                            </h5>
                                            <!-- {{statusOrder(titleReceipt.status)}} -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-4" v-if="titleReceipt.history_ref.from.ref_no">
                                <h5 class="p-1"><span class="label">รหัสอ้างอิง: </span>
                                    <router-link tag="a" :to="{name: 'cancelorders', 
                                        params: {orderId: titleReceipt.history_ref.from.ref_id}}">
                                        <u>{{titleReceipt.history_ref.from.ref_no}}</u>
                                    </router-link>
                                </h5>
                            </div>
                            <div class="col-lg-4">
                                    <h5 class="p-1"><span class="label">ชื่อผู้ส่ง: </span><span class="text-value">{{ (titleReceipt.sender.name) ? titleReceipt.sender.name : '-' }}</span></h5>
                            </div>
                            <div class="col-lg-4">
                                    <h5 class="p-1"><span class="label">เลขประจำตัวประชาชน: </span><span class="text-value">{{ (titleReceipt.sender.id_no) ? titleReceipt.sender.id_no : '-' }}</span></h5>
                            </div>
                            <div class="col-lg-4">
                                    <h5 class="p-1"><span class="label">แคชเชียร์: </span><span class="text-value">{{titleReceipt.cashier}}</span></h5>
                            </div>
                            <div class="col-lg-4">
                                    <h5 class="p-1"><span class="label">ชื่อสมาชิก: </span><span class="text-value">{{ (titleReceipt.sender.name) ? titleReceipt.sender.name : '-' }}</span></h5>
                            </div>
                            <div class="col-lg-4">
                                    <h5 class="p-1"><span class="label">เบอร์โทรผู้ส่ง: </span><span class="text-value">{{ (titleReceipt.sender.tel) ? titleReceipt.sender.tel : '-' }}</span></h5>
                            </div>
                            <div class="col-lg-4">
                                    <h5 class="p-1"><span class="label">ยอดเงินรวม: </span><span class="text-value">{{titleReceipt.total}}</span></h5>
                            </div>
                            <div class="col-lg-4">
                                    <h5 class="p-1"><span class="label">ส่วนลด: </span><span class="text-value">{{titleReceipt.discount}}</span></h5>
                            </div>
                            <div class="col-lg-4">
                                    <h5 class="p-1"><span class="label">ยอดสุทธิ: </span><span class="text-value">{{(titleReceipt.total - titleReceipt.discount) | numFormat('0,0.00')}}</span></h5>
                            </div>
                        </div>
                    </div>
                </b-card>
            </div>
            <div class="col-lg-12 mt-4">
                <div class="row">
                    <div class="col-lg-8">
                        <button 
                            v-if="titleReceipt.status !== 'CANCEL'"
                            class="btn btn-danger cancel-button" 
                            :disabled="selected.length < 1"
                            @click="showConfirm()">
                            ยกเลิกรายการ {{selected.length > 0 ?'('+selected.length+')' : ''}}
                        </button>
                    </div>
                    <div class="col-lg-4">
                        <b-form-input v-model="filterTable" type="text" placeholder="ค้นหาข้อมูลในตาราง"></b-form-input>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 mt-4">
                <b-table 
                    ref="cancelOrderTable" 
                    :items="itemsFilter" 
                    :fields="fields"
                    :filter="filterTable"
                    @row-selected="onRowSelected"
                    responsive show-empty selectable hover>
                    <template slot="HEAD_selected">
                        <b-form-checkbox v-model="checkSelect"
                            @change="selectAllRows()">
                        </b-form-checkbox>
                    </template>
                    <template slot="selected" slot-scope="{ rowSelected , item }">
                        <template v-if="rowSelected">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" autocomplete="off" class="custom-control-input" value="true" checked>
                                <label class="custom-control-label"></label>
                            </div>
                        </template>
                        <template v-else-if="item.hasOwnProperty('_rowVariant')">
                        </template>
                        <template v-else>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" autocomplete="off" class="custom-control-input" value="false">
                                <label class="custom-control-label"></label>
                            </div>
                        </template>
                    </template>
                    <template slot="item_name" slot-scope="data">
                       <template v-if="data.item.courier">{{data.item.courier}}</template>
                       <template v-else>{{data.item.name}}</template>
                    </template>
                    <template slot="barcode" slot-scope="data">
                       <template v-if="data.item.barcode">{{data.item.barcode}}</template>
                       <template v-else>{{'-'}}</template>
                    </template>
                    <template slot="status" slot-scope="data">
                        <b-badge :variant="statusCourier(data.item.status).color +' report'" >
                            {{statusCourier(data.item.status).status}}
                        </b-badge>
                    </template>
                    <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                    <template slot="dimension" slot-scope="row">
                        <template v-if="row.item.dimension">
                            {{ row.item.dimension.width }} x {{ row.item.dimension.length }} x 
                            {{ row.item.dimension.height }}
                        </template>
                        <template v-else>{{'-'}}</template>
                    </template>
                    <template slot="receiver" slot-scope="data">
                        <template v-if="data.item.receiver">{{ data.item.receiver.name }}</template>
                        <template v-else>{{'-'}}</template>
                    </template>
                    <template slot="receiver_tel" slot-scope="data">
                        <template v-if="data.item.receiver">{{ data.item.receiver.tel }}</template>
                        <template v-else>{{'-'}}</template>
                    </template>
                    <template slot="price" slot-scope="data">
                        <template>{{ (data.item.price) ? data.item.price : '-' }}</template>
                    </template>
                    <template slot="insurance_remark" slot-scope="data">
                        <template>{{ (data.item.insurance_remark) ? data.item.insurance_remark : '-' }}</template>
                    </template>
                    <template slot="weight" slot-scope="row">
                        {{ (row.item.weight) ? ( ( $THEME.unitKG ) ? (row.item.weight / 1000) : row.item.weight ) : '-'}}
                    </template>
                </b-table>
            </div>
        </b-card>
        <ModalConfirmCancel :confirmCancel="confirmCancel"/>
        <ModalAlertCancel :alertCancel="alertCancel"/>
        <ModalNoti :getMsg="modalNoti.msg" 
            :getShow="modalNoti.show" 
            :getType="modalNoti.type"
            :submit="modalNoti.funcSubmit" />
        <ModalError :error="error"/>
    </div>
</div>
</template>
<script>
import BtnLabel from '@/components/custom/printLabel/BtnLabel'
import ModalConfirmCancel from '@/components/Modals//ModalConfirmCancel'
import ModalAlertCancel from '@/components/Modals//ModalAlertCancel'
import ModalError from '@/components/Modals//ModalError'
import ModalNoti from '@/components/Modals//Modal-noti'
import { statusCourier } from "@/plugins/statusCourier.js"
import { statusOrder } from "@/plugins/statusOrder.js"
import insurance from '@/insurances/Insurance';

export default {
    mounted(){
        this.getOrder()
        this.userLogin = JSON.parse(localStorage.getItem("user"));
    },
    components:{
        BtnLabel,
        ModalConfirmCancel,
        ModalAlertCancel,
        ModalNoti,
        ModalError
    },
    
    data(){
        return {
            busy: false,
            orderId: this.$route.params.orderId,
            rawTitleReceipt:{},
            historyRef: false,
            items:[],
            filterTable:"",
            checkSelect:"",
            selected:[],
            confirmCancel:{
                show: false,
                number: 0,
                remark: '',
                funcRemoveItem: this.removeItem
            },
            alertCancel:{
                show: false,
                type: 'success',
                funcConfirm: this.printReceipt,
                receiptId: 0,
                tracking: []
            },
            modalNoti:{
                msg: "",
                show: false,
                type: false,
                funcSubmit: this.toggleModalNoti
            },
            statusCourier: statusCourier,
            statusOrder: statusOrder,
            error:{
                show: false
            }
        }
    },
    beforeCreate() {
        this.userLogin = JSON.parse(localStorage.getItem("user"));
    },
    computed:{
        fields(){ 
            let fields = [
                { key: "selected", label: "checkbox" },
                { key: "index", label: "#", sortable: true },
                { key: "item_name", label: "ชื่อสินค้า", sortable: true },
                { key: "barcode", label: "หมายเลข TRACKING", sortable: true },
                { key: "status", label: "สถานะจัดส่งพัสดุ", sortable: true, class: "text-center" },
                { key: "dimension", label: "ขนาดพัสดุ", sortable: true },
                { key: "weight", label: ( this.$THEME.unitKG ) ? 'น้ำหนัก (กิโลกรัม)':'น้ำหนัก (กรัม)', sortable: true },
                { key: "receiver", label: "ชื่อผู้รับ", sortable: true },
                { key: "receiver_tel", label: "เบอร์โทรผู้รับ", sortable: true },
                { key: "address", label: "ที่อยู่ผู้รับ", sortable: true },
                { key: "price", label: "ยอดสุทธิ", class:"text-right" },
                { key: "cod_amount", label: "ยอด COD", class:"text-right" },
                { key: "remote_area", label: "ค่าบริการพื้นที่พิเศษ", class:"text-right" },
                { key: "insurance_price", label: "ค่าประกันสินค้า", class:"text-right" },
                { key: "insurance_remark", label: "ประเภทสินค้า", class: "text-center" },
            ]
            return fields
        },
        titleReceipt(){
            const sender = {
                'cashier': '-',
                'create_at': '-',
                'receipt_no': '-',
                'total': '-',
                'sender': {
                    'id_no': '-',
                    'name': '-',
                    'tel': '-'
                },
                'history_ref': {
                    'from': {
                        'ref_id': '-',
                        'ref_no': '-',

                    },
                    'from': {
                        'to': '-',
                        'ref_no': '-',

                    }
                },
                'status': '-'
            }
            return this.rawTitleReceipt.sender ? this.rawTitleReceipt : sender
        },
        itemsFilter() {
            var items = [];
            if (this.items.length > 0) {
                items = Object.assign([], this.items);
                items.forEach((item) => {
                    if (item.status != 'BOOKING' && item.status != null) {
                        item = this.setRowVariant(item);
                    }
                });
            }
            return items;
        },
    },
    methods:{
        isWho() {
            return this.userLogin.role;
        },
        showConfirm(){
            this.confirmCancel.number = this.selected.length > 0 ? this.selected.length : 0
            this.confirmCancel.show = true
        },
        getOrder(){
            if( !this.$route.params.orderId ){
                this.$router.push('/')
                return false
            }
            this.busy = true
            this.$http.post( this.$API_URL + "/shop/check", {
                receipt: this.$route.params.orderId,
                type: false
            },
            {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            }).then( res => {
                const data = res.data.data
                this.rawTitleReceipt = data.data
                if (this.rawTitleReceipt.history_ref) {
                    this.historyRef = this.rawTitleReceipt.history_ref
                }
                if (data.data.status === 'CANCEL') {
                    this.fields = this.fields.filter((f) => { return f.key !== 'selected'})
                }
                this.items = data.items
                this.busy = false
            })
        },
        async removeItem() {
            this.busy = true
            await this.$http.delete( this.$API_URL + "/shop/order/" + this.orderId, {
                headers: {
                    Token: localStorage.getItem("access_token")
                },
                data: {
                    list_cancel: this.selected,
                    remark: this.confirmCancel.remark
                }
            }).then(res => {
                this.busy = false
                const results = res.data
                if( results.status ){
                    const countListFail = results.data.list_fail.length
                    if( countListFail < 1 ){
                        this.modalAlertCancel( 'success', results.data.receipt_id )
                    }else{
                        this.modalAlertCancel( 'error', results.data.receipt_id )
                    }
                }else{
                    this.setModalNoti(results.error)
                }
            })
        },
        modalAlertCancel( type , receiptId ){
            this.alertCancel.show = true
            this.alertCancel.type = type
            this.alertCancel.receiptId = receiptId

        },
        toggleModalNoti(){
            this.modalNoti.show = !this.modalNoti.show
            this.modalNoti.msg = "";
        },
        setModalNoti( error ){
            if(error.code == 'ORDER_ID_NOT_FOUND'){
                this.modalNoti.msg = error.msg;
            }else{
                error.list_fail.forEach( error => {
                    if(error.msg == 'Error : Unable to cancel uncomplete or shipping order'){
                        error.msg = 'ไม่สามารถยกเลิกรายการนี้ได้เนื่องจากพัสดุได้ถูกจัดส่งแล้วหรือพัสดุได้ถูกยกเลิกแล้ว'
                    }
                    this.modalNoti.msg += `${error.msg} ${error.tracking_code}`;
                })
            }
            this.modalNoti.show = true
        },
        onRowSelected(items){
            let listSelected = []
            let trackingSelected = []
            items.forEach((items, index) => {
                if (items.status != 'BOOKING' && items.status != null) {
                    this.unselectRow(index)
                } else {
                    listSelected.push(items.id)
                    trackingSelected.push(items.barcode)
                }
            })
            this.selected = listSelected
            this.alertCancel.tracking = trackingSelected
        },
        selectAllRows(){
            this.checkSelect = !this.checkSelect
            if (this.checkSelect){
                this.$refs.cancelOrderTable.selectAllRows()
            }else{
                this.$refs.cancelOrderTable.clearSelected()
            }
        },
        unselectRow(index) {
            this.$refs.cancelOrderTable.unselectRow(index)
        },
        setRowVariant(item) {
            return (item._rowVariant = "row-disabled");
        },
        async printReceipt( id ) {
            await this.$http.get( this.$API_URL + `/order/${ id }/receipt`, {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            }).then(res => {
                const win = window.open('')
                let html = res.data.data
                win.document.write(html);
                setTimeout(() => {
                    win.document.close();
                    win.focus();
                    win.print();
                    win.close();
                }, 100);
            })
        }
    },
    watch: {
        $route(to, from) {
            window.location.reload()
        }
        // '$route.params.orderId': function (o, n) {
        //    console.log(o,n)
        //     if (o != n) {
        //         window.location.reload()
        //     }
        // }
    },
}
</script>